import { Validate } from "./validate";
import { displayGenericError, displayInputErrorMarkup } from "./failhandler";

var eldsjalnomination = (function () {
    "use strict";

    var cl;

    if ($('.eldsjalnomination').length > 0) {
        
        var $eldsjalcontainer = $('.eldsjalnomination'),
		$nominationcategorycontainer = $('.nominationcategory', $eldsjalcontainer),
        $nominationformscontainer = $('.nominationforms', $eldsjalcontainer),
        $personform = $('.personform', $nominationformscontainer),
        $associationform = $('.associationform', $nominationformscontainer),
        $ageselect = $('select', $personform);

        $eldsjalcontainer.on('click', '.form input[type="submit"]', submitHandler);
        $eldsjalcontainer.on('blur', '.form-item input', blurHandler);
        $associationform.on('change', '#association-id', resetAssociationFormErrors);

        cl = new CanvasLoader('loader');

        cl.setDiameter(20);
        cl.setDensity(17);
        cl.setRange(1.1);
        cl.setSpeed(1);
        cl.setColor('#ffffff');
        cl.setFPS(24);

        $('input[type=radio]', $nominationcategorycontainer).change(function () {
            $eldsjalcontainer.removeClass("adult").removeClass("youth").removeClass("friend").removeClass("association").addClass($(this).attr("id"));
            $nominationformscontainer.show();
            if ($personform.length > 0) { Validate.reset.call($personform) };
            if ($associationform.length > 0) { Validate.reset.call($associationform) };
            resetAssociationFormErrors();
            $('h4', $nominationformscontainer).first().text($(this).parent().find('label').text());
            $("#category").val($(this).parent().find('label').text());
            $('.nominationforms > .form').hide();
            switch($(this).attr("id"))
            {
                case 'adult':
                    $('option', $ageselect).removeAttr('disabled');
                    $ageselect.trigger("liszt:updated");
                    $(".introyouth", $personform).hide();
                    $(".introfriend", $personform).hide();
                    $(".introadult", $personform).show();
                    $personform.show();
                    break;
                case 'youth':
                    $('option', $ageselect).each(function (index, value) {
                        if (index > 2) {
                            $(this).attr('disabled', 'disabled');
                        }
                    });
                    $ageselect.trigger("liszt:updated");
                    $(".introadult", $personform).hide();
                    $(".introfriend", $personform).hide();
                    $(".introyouth", $personform).show();
                    $personform.show();
                    break;
                case 'friend':
                    $(".introyouth", $personform).hide();
                    $(".introadult", $personform).hide();
                    $(".introfriend", $personform).show();
                    $personform.show();
                    break;
                case 'association':
                    $associationform.show();
                    break;
                default:
                    break;
            }
        });

        /*$(document).ready(function () {
            $('input[type=radio]:first', $nominationcategorycontainer).prop('checked', true).trigger('change');
        });*/
    }

    function submitHandler(e) {
        e.preventDefault();

        var $form = $(this).closest('.form'),
           $inputs = $form.find('.form-item input, .form-item textarea'),
           $eldsjalcontainer = $('.eldsjalnomination'),
           $nominationcategorycontainer = $('.nominationcategory', $eldsjalcontainer),
           $radiobutton = $('input:checked', $nominationcategorycontainer),
           $ageselect = $('select', $form),
           validated = true,
           request = {},
           data = {};

        $inputs.each(function () {
            if ($(this).is(":visible") && !$(this).parent().hasClass('chzn-search')) {
                if (!Validate.validate.call($(this))) {
                    validated = false;
                }
            }
        });

        resetAssociationFormErrors();
        
        if ($form.find("#association-id").length > 0) {
            if ($form.find("#association-id").val() === '') {
                $form.find(".form-message").text($form.find(".form-message").data("error-message")).addClass("error").show();
                $form.find(".picked-association p").addClass("error");
                validated = false;
            }
        }

        if (validated) {
            request['pageid'] = SETTINGS.pageid;
            request['language'] = SETTINGS.language;
            request['nominationcategory'] = $radiobutton.attr("id");
            switch ($radiobutton.attr("id")) {
                case 'adult':
                case 'youth':
                case 'friend':
                    request['age'] = $ageselect.val();
                    $inputs.each(function () {
                        if ($(this).is(":visible") && !$(this).parent().hasClass('chzn-search')) {
                            var $this = $(this),
                                prop = $this.attr('name'),
                                value = $this.val();

                            request[prop] = value;
                        }
                    });
                    break;
                case 'association':
                    request["associationid"] = $form.find("#association-id").val();
                    request["association"] = $form.find("#association-name").val();
                    break;
                default:
                    break;
            }

            data['request'] = request;
            $(this).val($(this).data("sendingtext"));
            cl.show();
            var ajaxRequest = $.ajax({
                url: SETTINGS.services.forms.methods.eldsjalnomination,
                method: 'POST',
                data: JSON.stringify(data)
            });

            ajaxRequest.done(doneHandler);
            ajaxRequest.fail(failHandler);
        }
    }
    function doneHandler(response) {
        var $eldsjalcontainer = $('.eldsjalnomination'),
           $nominationcategorycontainer = $('.nominationcategory', $eldsjalcontainer),
           $nominationformscontainer = $('.nominationforms', $eldsjalcontainer),
           $confirmationcontainer = $('.confirmation', $eldsjalcontainer),
           $radiobutton = $('input:checked', $nominationcategorycontainer),
           $form = $radiobutton.attr("id") == "association" ? $('.associationform', $nominationformscontainer) : $('.personform', $nominationformscontainer);

        if (response.Success) {
            $nominationcategorycontainer.hide();
            $nominationformscontainer.hide();
            $('input', $nominationcategorycontainer).attr('checked', false);
            $("p", $confirmationcontainer).text($("p", $confirmationcontainer).text().replace("{0}", response.NominationName));
            $confirmationcontainer.show();
            $.scrollTo('.eldsjalnomination', 800, { offset: { top: -100 } });
        } else {
            displayGenericError($form.find(".form-message"), response);
            displayInputErrorMarkup($form, response);
        }

        cl.hide();
        $('input[type="submit"]', $nominationformscontainer).each(function () { $(this).val($(this).data("sendtext")) });

    }

    function failHandler(response) {
        cl.hide();
        $('.nominationforms input[type="submit"]').each(function () { $(this).val($(this).data("sendtext")) });
    }

    function blurHandler() {
        Validate.validate.call($(this));
    }

    function resetAssociationFormErrors() {
        $(".eldsjalnomination .associationform .form-message").text('').removeClass("error").hide();
        $(".eldsjalnomination .associationform .picked-association p").removeClass("error");
    }

})();